<template>
    <div class="mortgage-status-setting">
        <CreateNewRoleAccessModal :create_new_role_access.sync="modals.create_new_role_access" v-on:closeModal="closeModal()" :available_group_access="available_group_access" />
        <base-header class="pb-6">
            <b-row align-v="center" class="py-3">
                <b-col cols="6">
                    <h2 class="listing-title d-inline-block mb-0">Role Access Setting</h2>
                </b-col>
                <b-col cols="6" class="text-right ">
                    <b-button variant="primary" class="btn-header" @click="openModal">Create New</b-button>
                </b-col>
            </b-row>
            
        </base-header>
        <b-container fluid class="mt--6">
            <RoleAccessTable :available_group_access="available_group_access" />
        </b-container>
    </div>
</template>
<script>
import RouteBreadCrumb from '@/components/Breadcrumb/RouteBreadcrumb'
import RoleAccessTable from '@/views/Configurations/RoleAccessSettings/RoleAccessTable'
import CreateNewRoleAccessModal from '@/views/Configurations/RoleAccessSettings/RoleAccessModals/CreateNewRoleAccessModal'
import {
	axios,
	services,
	getHeader
} from '@/assets/js/httpImports.js'

export default {
    components: {
				RoleAccessTable,
        RouteBreadCrumb,
        CreateNewRoleAccessModal
    },
    data() {
        return {
            modals: {
                create_new_role_access: false
            },
						available_group_access: []
        }
    },
		created() {
			this.getAvailableAccess();
		},
    methods: {
        openModal() {
            this.modals.create_new_role_access = true;
        },
        closeModal(){
            this.modals.create_new_role_access = false;
        },
				getAvailableAccess() {
					axios.get(services.access_control + 'available_access_code', { headers: getHeader() })
						.then(res => {
							this.available_group_access = res.data.data;
						})
						.catch(e => {
							this.errorFunction(e)
						})
				},
    }
}
</script>